import  authReducer  from "./Reducers/authReducer"
import categoryReducer from './Reducers/categoryReducer'
import productReducer from './Reducers/productReducer'
import sellerReducer from './Reducers/sellerReducer'
import chatReducer from './Reducers/chatReducer'
import OrderReducer from './Reducers/OrderReducer'
import dashboardIndexReducer from './Reducers/dashboardIndexReducer'
import bannerReducer from './Reducers/bannerReducer'
import customerReducer from './Reducers/customerReducer.js';
import adminDigitalProductReducer from './Reducers/adminDigitalProductReducer.js'
import dopingReducer from './Reducers/dopingReducer.js' 
// import  adminWalletReducer  from "./Reducers/adminWalletReducer.js"
import sellerShopReducer from "./Reducers/sellerShopReducer"
import ticketReducer from "./Reducers/ticketReducer.js"
import PaymentReducer from "./Reducers/PaymentReducer.js"
import balanceReducer from "./Reducers/balanceReducer.js"
import commissionReducer from './Reducers/commissionReducer'
import blogReducer from './Reducers/bloggReducer.js'
import aboutReducer from './Reducers/aboutReducer'
import  cashbackReducer  from "./Reducers/cashbackReducer.js"
import adminGiveawayReducer from './Reducers/adminGiveawayReducer.js'
import adminCampaignReducer from './Reducers/adminCampaignReducer.js'
import sellerGiveawayReducer from './Reducers/sellerGiveawayReducer.js'
import supportTicketReducer from './Reducers/supportTicketReducer.js'
import sellerSupportReducer from './Reducers/sellerSupportReducer.js'
import staffReducer from './Reducers/staffReducer.js'
import internalChatReducer from './Reducers/internalChatReducer.js'
import securityReducer from './Reducers/securityReducer.js'
const rootReducer = {
    auth: authReducer,
    category: categoryReducer,
    product: productReducer,
    seller: sellerReducer,
    chat: chatReducer,
    order: OrderReducer,
    payment: PaymentReducer,
    dashboardIndex: dashboardIndexReducer,
    banner : bannerReducer,
    customer: customerReducer,
    adminDigitalProduct: adminDigitalProductReducer,
    doping: dopingReducer,
    // adminWallet: adminWalletReducer,
    sellerShopReducer,
    ticket: ticketReducer,
    balance: balanceReducer,
    commission: commissionReducer,
    blog : blogReducer,
    about: aboutReducer, 
    cashback: cashbackReducer,
    adminGiveaway: adminGiveawayReducer,
    adminCampaign: adminCampaignReducer,
    sellerGiveaway: sellerGiveawayReducer,
    supportAdmin: supportTicketReducer,
    sellerSupport: sellerSupportReducer,
    staff: staffReducer,
    internalChat: internalChatReducer,
    security: securityReducer,
}
export default rootReducer